import {IonIcon} from "@ionic/react";
import styles from './styles.module.scss'

export const ToolbarActionButton = ({icon, onClickFunction}) =>{
  return (
    <div className={styles.toolbar_action_button}>
      <IonIcon icon={icon} onClick={onClickFunction ? ()=>{onClickFunction()} : null} />
    </div>
  )
}